import React, { FC, useEffect, useRef } from 'react'
import { useSearchParams } from 'react-router-dom'

// This wrapper is necessary because iOS and Android webviews do not work with the
// generic postMessage API. Instead, we need to use a specific message handler object.
// Since the iframe can work with the postMessage API, it can accept the messages and
// then forward them to the webview via the custom message handler object.
const IframeWrapper: FC = () => {
  const iframeRef = useRef(null)
  const [searchParams] = useSearchParams()

  // Use this to control what we will allow to be loaded in the iframe
  // and where messages will be allowed from
  const origin = window.location.origin

  useEffect(() => {
    const handleMessage = (event) => {
      // Verify the origin of the message for security
      if (event?.origin !== origin) {
        return
      }

      if (event?.data?.type === 'onSageExit') {
        // Our test iOS app exposes "jsHandler" as a message handler object
        const iosHandler = (window as any).webkit?.messageHandlers?.jsHandler
        const androidHandler = (window as any).jsHandler
        const jsHandler = iosHandler || androidHandler

        if (jsHandler?.postMessage) {
          jsHandler.postMessage(JSON.stringify(event.data.payload))
        } else {
          console.log('webkit.messageHandlers.jsHandler not found.')
        }
      }
    }

    window.addEventListener('message', handleMessage)

    return () => {
      window.removeEventListener('message', handleMessage)
    }
  }, [])

  const url =
    decodeURIComponent(searchParams.get('url')) + '&bypassIframeCheck=true'

  const urlObject = new URL(url)

  // If the URL origin is not the same as the origin of the page, do not allow the iframe to be loaded
  if (urlObject.origin !== origin) {
    return <div>Invalid origin</div>
  }

  return (
    <iframe
      ref={iframeRef}
      title="Iframe Wrapper"
      src={url}
      style={{
        width: '100%',
        height: '100%',
        position: 'fixed',
        top: '0px',
        left: '0px',
        border: 'none',
      }}
    />
  )
}

export default IframeWrapper
